import { useCallback } from 'react'

import filestack from 'common/filestack'

export const FILE_PICKER_CONFIG = {
  multiple: false,
  mimetypes: ['image/png', 'image/jpeg', 'image/pjpeg'],
  cropRatio: 1,
  cropForce: true,
  services: ['CONVERT', 'COMPUTER', 'FACEBOOK', 'GOOGLE_DRIVE', 'DROPBOX', 'INSTAGRAM', 'FLICKR', 'URL', 'WEBCAM'],
}

const getPickerStoreOptions = (scid?: number) => ({
  location: 'GCS',
  path: `/${window.FILE_STACK_GCS_ROOT_PATH}/college-content/${scid}/`,
})

export interface IimageObject {
  container: string
  url: string
  filename: string
  mimetype: string
  key?: string
  size: number
}

interface IUseImageUpload {
  scid?: number
  setImageUploadOpen: (open: boolean) => void
  onPickImage: (image: IimageObject) => void
}

export const useImageUpload = ({ scid, onPickImage, setImageUploadOpen }: IUseImageUpload) => {
  const onChooseImage = useCallback(
    (e) => {
      e.stopPropagation()
      setImageUploadOpen(true)
      filestack
        .pickAndStore(FILE_PICKER_CONFIG, getPickerStoreOptions(scid))
        .then((picked: IimageObject[]): void => {
          return onPickImage(picked[0])
        })
        .catch(() => setImageUploadOpen(false))
    },
    [scid, setImageUploadOpen, onPickImage],
  )

  return onChooseImage
}
